import qs from 'qs';

export const createdEndOfUrl = (filters, startFilter) => {
    if (filters) {
        let newVlues = {};
        let test = qs.parse(filters, { ignoreQueryPrefix: true }).filter;

        test &&
            Object.keys(test).map((key) => {
                if (key !== 'size' && key !== 'page') {
                    newVlues[`filter[${key}]`] = test[key];
                }
            });
        // filterBy.map(item => {
        //   Object.keys(filters).map((key, index) => {
        //     if (item === key) newVlues[key] = filters[key]
        //   })
        // })  In future realize with props to excelButton filterBy[order,something]

        const getParams = `${startFilter ? '&' : '?'}${qs.stringify(newVlues, { encode: true })}`;

        return getParams;
    }
    return '';
};
